import { Classes } from "@blueprintjs/core";
import { useNavigate } from "react-router";

import { Box, Flex } from "@/components/layout/flexbox";
import { OrderDetailTable } from "@/components/pieces/buy-credits/OrderDetailTable";
import { AvailableCreditsContainer } from "@/components/pieces/coaching/available-credits/AvailableCredits";
import { ConfettiOverlay } from "@/components/pieces/confetti";
import { CARD_CLASSES, SUPPORT_EMAIL } from "@/css/constants";
import { useOrderQuery } from "@/graphql";

export function BuyCreditsSuccess({ id }: { id: string }) {
  const navigate = useNavigate();
  const { data, loading } = useOrderQuery({
    variables: { id },
    skip: !id,
    errorPolicy: "all",
  });
  if (!id || (!loading && data && !data.order)) {
    navigate("/buy");
    return null;
  }
  if (loading) {
    return <Box width={1} height={200} mb={5} className={Classes.SKELETON} />;
  }
  if (!data?.order) {
    navigate("/buy");
    return null;
  }
  const order = data.order;
  return (
    <>
      <ConfettiOverlay recycle={false} />
      <Flex
        py={3}
        px={[3, 24]}
        mb={5}
        className={CARD_CLASSES}
        backgroundColor="#FFF"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
      >
        <AvailableCreditsContainer
          title={order.ledgerAccount?.label ?? ""}
          creditAmount={order.ledgerAccount?.balance ?? undefined}
          ctaButton={null}
          secondaryButton={null}
        />
      </Flex>
      <Box fontSize={22} fontWeight={600}>
        Order #{order.id}
      </Box>
      <Box className={CARD_CLASSES} backgroundColor="#FFF" mt={3} p={24}>
        <OrderDetailTable order={order} paymentType={order.paymentType ?? ""} />
      </Box>
      <Box mt={4}>
        Have a question about your order?{" "}
        <a target="_blank" href={`mailto:${SUPPORT_EMAIL}`}>
          Contact support
        </a>
      </Box>
    </>
  );
}
